export class AppPermissions {
    
    public static LOGGED_IN = 'UserLoggedIn';
    public static NOT_LOGGED_IN = 'UserNotLoggedIn';
    public static SUB_USER = 'subUser';
    public static DEADLINE = 'timetable';
    public static SERVICING = 'servicing';
    public static HUMAN_RESOURCE = 'human_resource';
    public static MEASUREMENT_TOOL = 'mesurement_tool';
    public static PROBLEM_SOLVING = 'problem_solving';
    public static DOCUMENT_MANAGEMENT = 'doc_management';
    public static CUSTOMERS = 'clients';
    public static CONSULTANCY = 'consultancy';
    public static ACADEMY = 'academy';
    public static PROJECT = 'project';
    public static AUDIT = 'audit';
    public static ADMIN_TICKET = 'admin_ticket';
    public static INSTALLATION_LIST = 'installation_list';
    public static MAINTENANCE_PLANS = 'maintenance_plans'
    public static Servicing_List = 'servicing'
    public static READ = '1';
    public static WRITE = '2';

    public static WRITE_PERM = [AppPermissions.READ, AppPermissions.WRITE];
    public static READ_PERM = [AppPermissions.READ];


 }


 export class AdminAppPermissions {
    
    public static LOGGED_IN = 'UserLoggedIn';
    public static NOT_LOGGED_IN = 'UserNotLoggedIn';
    public static INSTALLATION_LIST = 'installation_list';
    
    public static READ = '1';
    public static WRITE = '2';

    public static WRITE_PERM = [AppPermissions.READ, AppPermissions.WRITE];
    public static READ_PERM = [AppPermissions.READ];


 }
